const stage = {
  1: '一拍',
  2: '二拍',
  3: '变卖'
}

const status = {
  1: '即将开始',
  2: '扣押中',
  3: '拍卖中',
  4: '已拍卖',
  5: '流拍',
}

const type = { 1: '车辆', 2: '房产', 3: '其他' }
export const stageKey = (val) => {
  return stage[val]
}
export const statusKey = (val) => {
  return status[val]
}
export const typeKey = (val) => {
  return type[val]
}
export default {
  stage,
  type,
  status
}